<template>
    <div>
        <SrButton v-if="closeAble" class="close-icon-wrapper" icon small color="grey" @click="close">
            <SrIcon icon="close" size="xxs" />
        </SrButton>
        <div class="header">
            <slot name="header" />
        </div>
        <div class="content-scroll-wrapper">
            <div class="content">
                <slot name="content" />
            </div>
        </div>
    </div>
</template>

<script>
import SrIcon from '../../components/SrIcon/SrIcon';
import SrButton from '../../components/SrButton/SrButton';

export default {
    name: 'SrModalPageBasic',
    components: { SrIcon, SrButton },
    props: {
        /**
         * Shows "X" button in top right corner to close modal.
         */
        closeAble: {
            type: Boolean,
            default: true,
        },
    },
    methods: {
        close() {
            this.$emit('close');
        },
    },
};
</script>
